import { render, staticRenderFns } from "./bfhs-button.vue?vue&type=template&id=8121ed60&scoped=true"
import script from "./bfhs-button.vue?vue&type=script&lang=js"
export * from "./bfhs-button.vue?vue&type=script&lang=js"
import style0 from "./bfhs-button.vue?vue&type=style&index=0&id=8121ed60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8121ed60",
  null
  
)

export default component.exports